import {engineContext} from './context.js';

(function(g){'use strict';
const VERSION='0.1.0-alpha';
function freeze(v){if(v&&typeof v==='object'&&!Object.isFrozen(v)){Object.freeze(v);for(const x of Object.values(v))freeze(x);}return v;}
function need(name,method){const x=g[name];if(!x||typeof x[method]!=='function')throw Error(name+'_'+method+'_REQUIRED');return x;}
function norm(v){return String(v||'').trim().toUpperCase();}
function create(opts={}){
  const runtime=need('ZooInvestRuntimeUIV406','create').create(opts.runtimeOptions||{});
  const repository=opts.repository||need('ZooInvestRevisionAwareRepository','create').create(opts.repositoryOptions||{});
  const journal=opts.journal||need('ZooInvestResearchStateEventJournal','create').create(opts.journalOptions||{});
  const now=opts.now||(()=>new Date().toISOString());

  async function restore(symbol,scope='RESEARCH'){
    const s=norm(symbol); if(!s)throw Error('SYMBOL_REQUIRED');
    try{
      const x=await repository.load(s,scope);
      if(x.error)return freeze({status:'REVIEW',symbol:s,scope,record:null,error:x.error});
      return freeze({status:x.found?'RESTORED':'EMPTY',symbol:s,scope,record:x.record||null});
    }catch(e){
      return freeze({status:'REVIEW',symbol:s,scope,record:null,error:String(e.message||e)});
    }
  }

  async function run(req={},root){
    const symbol=norm(req.symbol),scope=req.scope||'RESEARCH';
    if(!symbol)throw Error('SYMBOL_REQUIRED');
    const restored=await restore(symbol,scope);
    const expectedRevision=restored.record?.revision||0;

    let runtimeResult;
    try{
      runtimeResult=await runtime.runAndBind({...req,symbol,scope,previousState:restored.record||null},root);
    }catch(e){
      return freeze({version:VERSION,symbol,scope,status:'REVIEW',restore:restored,runtime:null,persistence:{state:'NOT_ATTEMPTED'},journal:{state:'NOT_ATTEMPTED'},issues:[{stage:'RUNTIME',message:String(e.message||e)}]});
    }

    const research=runtimeResult.research||{};
    const payload={
      symbol,scope,savedAt:now(),
      evidenceFingerprint:runtimeResult.researchInput?.evidenceFingerprint||null,
      thesisFingerprint:runtimeResult.researchInput?.thesisFingerprint||null,
      snapshot:research.snapshot||null,
      readiness:research.integrityGate||null,
      integrity:research.integrity||null,
      brief:research.brief||null,
      completionMemory:research.completionMemory||[],
      openGaps:runtimeResult.researchInput?.openGaps||[],
      invalidations:research.invalidation||[],
      metadata:{
        runtimeVersion:runtimeResult.version||null,
        marketContextStatus:runtimeResult.marketContext?.status||null,
        execution:runtimeResult.execution||null
      }
    };

    let persistence;
    try{
      const saved=await repository.save(payload,{expectedRevision});
      persistence=saved.saved
        ?{state:'SAVED',revision:saved.revision,record:saved.record}
        :{state:saved.error&&saved.error.includes('REVISION')?'CONFLICT':'REVIEW',error:saved.error,actualRevision:saved.actualRevision,expectedRevision:saved.expectedRevision};
    }catch(e){
      persistence={state:'REVIEW',error:String(e.message||e)};
    }

    let journalState={state:'SKIPPED'};
    if(typeof journal.append==='function'){
      try{
        journal.append({
          symbol,scope,eventType:persistence.state==='SAVED'?'STATE_SAVED':'STATE_SAVE_REVIEW',
          revision:persistence.revision??null,
          occurredAt:now(),
          evidenceFingerprint:payload.evidenceFingerprint,
          thesisFingerprint:payload.thesisFingerprint,
          reason:persistence.error||null,
          payload:{runtimeStatus:runtimeResult.status,persistenceState:persistence.state}
        });
        journalState={state:'APPENDED'};
      }catch(e){journalState={state:'REVIEW',error:String(e.message||e)};}
    }

    let status=runtimeResult.status||'REVIEW';
    if(persistence.state!=='SAVED'||journalState.state==='REVIEW')status='REVIEW';

    return freeze({
      version:VERSION,symbol,scope,status,
      restore:restored,runtime:runtimeResult,
      persistence:freeze(persistence),journal:freeze(journalState),
      guards:freeze({
        revisionConcurrencyEnforced:true,
        revisionPersistedInRecord:true,
        staleWriteCannotBecomeReady:true,
        missingRevisionStartsAtZero:true,
        noTradeSignal:true,noCapitalPermission:true,noUniversalScore:true
      })
    });
  }
  return Object.freeze({VERSION,restore,run,repository,journal});
}
async function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const store=new Map(),events=[];
  const repo={
    async load(symbol,scope){const k=scope+':'+symbol;return store.has(k)?{found:true,record:store.get(k)}:{found:false,record:null};},
    async save(payload,o){
      const k=payload.scope+':'+payload.symbol,current=store.get(k)||null,actual=current?.revision||0;
      if(actual!==o.expectedRevision)return {saved:false,error:'REVISION_CONFLICT',actualRevision:actual,expectedRevision:o.expectedRevision};
      const record={...payload,revision:actual+1};store.set(k,record);return {saved:true,revision:record.revision,record};
    }
  };
  const journal={append:e=>events.push(e)};
  const runtime={
    async runAndBind(req){
      return {version:'X',status:'READY',symbol:req.symbol,marketContext:{status:'READY'},researchInput:{evidenceFingerprint:'e1',thesisFingerprint:null,openGaps:[]},research:{snapshot:{x:1},integrity:{state:'HEALTHY'},integrityGate:{gateState:'PASS'},brief:{attention:'NORMAL'},invalidation:[]},execution:{ok:true}};
    }
  };

  const old=g.ZooInvestRuntimeUIV406;
  try{
    g.ZooInvestRuntimeUIV406={create:()=>runtime};
    const api=create({repository:repo,journal,now:()=> '2026-08-31T17:30:00Z'});
    const a=await api.run({symbol:'aaa',scope:'OWNED'},null);
    ok('symbol normalized',a.symbol==='AAA');
    ok('new record saved',a.persistence.state==='SAVED');
    ok('first revision one',a.persistence.revision===1);
    ok('session ready after save',a.status==='READY');
    ok('journal appended',a.journal.state==='APPENDED');
    ok('journal records revision',events[0].revision===1);
    const restored=await api.restore('AAA','OWNED');
    ok('restore finds revision',restored.record.revision===1);
    const b=await api.run({symbol:'AAA',scope:'OWNED'},null);
    ok('second revision two',b.persistence.revision===2);

    const racingRepo={
      async load(){return {found:true,record:{symbol:'BBB',scope:'OWNED',revision:2}};},
      async save(payload,o){return {saved:false,error:'REVISION_CONFLICT',actualRevision:3,expectedRevision:o.expectedRevision};}
    };
    const api2=create({repository:racingRepo,journal,now:()=> 'T'});
    const c=await api2.run({symbol:'BBB',scope:'OWNED'},null);
    ok('race conflict explicit',c.persistence.state==='CONFLICT');
    ok('race conflict downgrades',c.status==='REVIEW');
    ok('revision guard true',c.guards.revisionConcurrencyEnforced===true);
    ok('revision persisted guard true',c.guards.revisionPersistedInRecord===true);
    ok('no trade signal guard',c.guards.noTradeSignal===true);
    ok('no capital permission guard',c.guards.noCapitalPermission===true);
    ok('no universal score guard',c.guards.noUniversalScore===true);
    let e=false;try{await api.run({symbol:''},null)}catch(x){e=x.message==='SYMBOL_REQUIRED'}ok('symbol required',e);
  } finally {g.ZooInvestRuntimeUIV406=old;}
  return freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:t});
}
g.ZooInvestRevisionAwareRuntimeSession=Object.freeze({VERSION,create,selfTest});
})(engineContext);